export default __webpack_public_path__ + "static/media/html5.3de4a8c5.png";